// Figma frame 15 · Glossary review (33:4102) — US-121.
//
// RE-HOSTED, NOT REWRITTEN. `ReviewPage` and everything under it is the
// product's primary human workflow; it was fully built and reachable by no
// URL for months (PRD 17 §1) and was only fixed on 2026-08-15. So this file
// wraps it and restyles it, and the accept / edit / reject / publish path
// underneath is untouched.
//
// Restyling is done entirely by re-pointing the four custom properties
// `review.css` reads that the paper chassis does not define — see
// `content.css`. Nothing here fights `review.css` selector-for-selector,
// which is what makes "restyled" a safe verb on this screen.
//
// ORG RESOLUTION. `/docs/$docId/review` is the one screen whose path carries
// no org, and nothing in the review payload reliably yields one: `corpus_id`
// maps to an org only by the naming convention `docs_list.py` documents, and
// a doc may have none at all. So the org rides in a `?org=` query written by
// the documents list, and a direct URL without it falls back to rendering
// `ReviewPage` bare — which is exactly its behaviour before this wave, and
// therefore the safest possible fallback for the flow that must not break.
//
// The shell itself is no longer drawn here: `routes/_shell.tsx` reads the same
// `?org=` and mounts one `AppShell` for every screen (US-152). The wrapper div
// stays because `content.css` scopes the restyling to it, and it is inert on
// the bare path where `[data-chassis="paper"]` never matches.

import "./content.css";
import { ReviewPage } from "../../review/ReviewPage";

export interface GlossaryReviewScreenProps {
  docId: string;
  /** From `?org=`. Null on a direct URL that did not carry one. */
  orgSlug: string | null;
}

export function GlossaryReviewScreen({ docId }: GlossaryReviewScreenProps) {
  return (
    <div className="maisight-content-review">
      <ReviewPage docId={docId} />
    </div>
  );
}
